<div class="p10">
    <div *ngIf="allowDelete" style="max-width:400px;">
        <div class="row">
            <div class="col-12">
                <span class="c-red fs20 bold">Are you sure you want to delete?</span>
            </div>
            <div class="col-12" style="margin-top:10px; margin-bottom:30px;">
                <h1 class="bold fs16">{{data.msg}}</h1>
            </div>
            <div class="col-6 text-left">
                <button mat-raised-button (click)="close()"> Close</button>
            </div>
            <div class="col-6 text-right">
                <button mat-raised-button color="warn" (click)="delete()"> <i class="fas fa-trash-alt c-white fs16 ibtn"></i> Delete</button>
            </div>
        </div>
    </div>
    <div *ngIf="allowDelete === false" style="max-width:400px;">
        <h1 class="c-red fs26">Sorry, you can not delete this.</h1>
        <h2 class="c-dark-grey bold">To delete this please add another income first. This Income section requires at lease one income to contine.</h2>
        <div style="width:100%; text-align: center; margin-top: 30px;">
            <button mat-stroked-button color="warn" (click)="close()">Close</button>
        </div>
    </div>
</div>